export enum FieldDomainEnum {
  FormalStudent = 'formal_student',
  FormalTeacher = 'formal_teacher',
  InformalStudent = 'informal_student',
  InformalTeacher = 'informal_teacher',
}
